import { render } from "./ModuleAggregateShortlist.vue?vue&type=template&id=410ef3d2&scoped=true"
import script from "./ModuleAggregateShortlist.vue?vue&type=script&lang=js"
export * from "./ModuleAggregateShortlist.vue?vue&type=script&lang=js"

import "./ModuleAggregateShortlist.vue?vue&type=style&index=0&id=410ef3d2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410ef3d2"]])

export default __exports__